import { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Table, Input, Card, CardBody, Label, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axiosInstance from 'pages/Utility/axiosInstance';
import { ClipLoader, FadeLoader } from 'react-spinners';
import { getCatalogItems, getTeams, getAddresses, fetchAddressesRequest, getShifts, getSebelUsers } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'components/Common/Breadcrumb2';
import toast from 'react-hot-toast';
import { showError, showSuccess } from 'helpers/notification_helper';
import { quantity } from 'chartist';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { convertDateFormat, fetchDateFromDateTime, formatDate, formatTime } from 'helpers/dateFormat_helper';
import WorkOrderDetails from './WorkOrderDetails';
import Cookies from 'js-cookie';
import AddMoreTeams from './MoreTeams';
import { IoCloseOutline } from "react-icons/io5";
import { addMinutesToTime } from 'helpers/common_helper';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Skeleton } from 'antd';



const EditWorkOrder = () => {
    const [selectedCatalogItem, setSelectedCatalogItem] = useState(null);
    const [catalogueItems, setCatalogueItems] = useState();
    const [itemQuantity, setItemQuantity] = useState('');
    const [workOrderDetails, setWorkOrderDetails] = useState();
    const [addresses, setAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState();
    const [workOrderItems, setWorkOrderItems] = useState([]);
    const [loading, setLoading] = useState(false);
    // const catalogItems = useSelector((state) => state.Catalog.catalogItems);
    const [catalogItems, setCatalogItems] = useState();
    const teams = useSelector((state) => state?.Team?.teams);
    const availableAddresses = useSelector((state) => state.Address.addresses);
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const shifts = useSelector((state) => state?.Shift?.shifts);
    const shiftsLoading = useSelector((state) => state?.Shift?.loading);
    const sebelUsersLoading = useSelector((state) => state.SebelUser.loading);
    const [uniqueTeams, setUniqueTeams] = useState();
    const [availableSlots, setAvailableSlots] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [bookedDates, setBookedDates] = useState()
    const [modal, setModal] = useState(false);
    const [selectedTime, setSelectedTime] = useState();
    const [highlightedSlot, setHighlightedSlot] = useState(null);
    const [selectedShift, setSelectedShift] = useState(null);
    const [scheduledStartDateTime, setScheduledStartDateTime] = useState();
    const [sebelUserId, setSebelUserId] = useState();
    const [serialNumber, setSerialNumber] = useState();
    const authUser = JSON.parse(Cookies.get('authUser'));
    const [loader, setLoader] = useState(false);
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fileError, setFileError] = useState('');
    const [invoiceFile, setInvoiceFile] = useState();
    const [visible, setVisible] = useState(false);
    const [serialNumbers, setSerialNumbers] = useState([]);
    const [modalSerialNoOpen, setModalSerialNoOpen] = useState(false);
    const [team, setTeam] = useState();
    const [tempTime, setTempTime] = useState();
    const [totalTime, setTotalTime] = useState();
    const [slotLoading, setSlotLoading] = useState(false);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [isCatalogLoading, setIsCatalogLoading] = useState(false);

    // Handle Serial Number Change
    const handleSerialNumberChange = (index, value) => {
        const updatedSerialNumbers = [...serialNumbers];
        updatedSerialNumbers[index] = value;
        setSerialNumbers(updatedSerialNumbers);
    };

    // Validate Serial Numbers
    const validateSerialNumbers = () => {
        if (serialNumbers?.some(item => !item)) {
            return showError("Please provide all serial numbers")
        }
        const uniqueSerials = new Set(serialNumbers);
        if (uniqueSerials.size !== serialNumbers.length) {
            showError("All serial numbers must be unique.");
            return false;
        }
        return true;
    };

    // Handle Confirm Serial Numbers and Add Item
    const handleConfirmSerialNumbers = () => {
        if (validateSerialNumbers()) {
            const newItem = {
                catalogueId: selectedCatalogItem?.value,
                catalogueItem: selectedCatalogItem?.label,
                estimatedInstallTimeInMins: selectedCatalogItem?.estimatedInstallTimeInMins,
                quantity: itemQuantity,
                perTime: selectedCatalogItem?.estimatedInstallTimeInMins,
                serialNumber: serialNumbers?.join(","), // Store all entered serial numbers
                image: selectedCatalogItem?.image,
                sku: selectedCatalogItem?.sku,
                model: selectedCatalogItem?.model,
            };

            setWorkOrderItems([...workOrderItems, newItem]);
            setScheduledStartDateTime('');
            setModalSerialNoOpen(false);
            resetForm();
        }
    };

    // Handle Add Work Order Item
    const handleAddWorkOrderItem = () => {
        if (!selectedCatalogItem) return alert("Please select a catalog item!");
        if (!itemQuantity || itemQuantity <= 0) return alert("Please enter a valid quantity!");

        // Check if item already exists
        if (workOrderItems?.filter(item => item?.catalogueId == selectedCatalogItem?.value)?.length === 1) {
            return showError("Catalogue item already exists!");
        }

        // If serial number is required, open modal
        if (selectedCatalogItem?.isRequired) {
            setSerialNumbers(new Array(Number(itemQuantity)).fill(""));
            setModalSerialNoOpen(true);
        } else {
            // Add item without serial numbers
            const newItem = {
                catalogueId: selectedCatalogItem?.value,
                catalogueItem: selectedCatalogItem?.label,
                estimatedInstallTimeInMins: selectedCatalogItem?.estimatedInstallTimeInMins,
                quantity: itemQuantity,
                perTime: selectedCatalogItem?.estimatedInstallTimeInMins,
                serialNumber: "",
                image: selectedCatalogItem?.image,
                sku: selectedCatalogItem?.sku,
                model: selectedCatalogItem?.model,
            };

            setWorkOrderItems([...workOrderItems, newItem]);
            setSelectedSlot("");
            setScheduledStartDateTime('');
            resetForm();
        }
    };

    // Reset Form
    const resetForm = () => {
        setSelectedCatalogItem(null);
        setItemQuantity("");
        setSerialNumbers([]);
    };

    const handleInvoiceFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file type
            if (file.type !== 'application/pdf') {
                setFileError('Only PDF files are allowed.');
                return;
            }

            setFileError('');

            // Convert file to base64
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setInvoiceFile(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    if (!permissions2?.map(item => item?.permissionName)?.includes("Edit Work Orders")) {
        navigate('/pages-403')
    }

    const fetchWorkOrderDetails = async () => {
        setLoader(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: 'usp_GetWorkorderProfile', WorkOrderId: id } });
            setWorkOrderDetails(response?.data?.Data?.[0]);
            setLoader(false);
        } catch (error) {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (workOrderDetails?.CustomerProfile) {
            dispatch(fetchAddressesRequest(JSON?.parse(workOrderDetails?.CustomerProfile)?.[0]?.customerId));
        }
        if (workOrderDetails?.WorkOrderItems) {
            setWorkOrderItems(JSON.parse(workOrderDetails?.WorkOrderItems))
        }

    }, [workOrderDetails?.CustomerProfile]);

    useEffect(() => {
        if (workOrderDetails?.WorkOrderLocationImages) {
            setImages(JSON.parse(workOrderDetails?.WorkOrderLocationImages)?.map(item => ({ imagePath: item?.imagePath, imageEvent: item?.imageEvent })))
            setImagePreviews(JSON?.parse(workOrderDetails?.WorkOrderLocationImages)?.map(item => (`${process.env.REACT_APP_BASE_URL}` + item?.imagePath)));
        }
    }, [workOrderDetails?.WorkOrderLocationImages])

    useEffect(() => {
        if (catalogItems?.Data?.length > 0) {
            const groupedByCategory = catalogItems?.Data?.reduce((acc, item) => {
                const { categoryName, itemName, catalogueId, estimatedInstallTimeInMins, isSerialNumberRequired, image } = item;

                // Check if the category already exists in the accumulator
                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }

                // Push the item into the respective category
                acc[categoryName].push({
                    value: catalogueId,
                    label: itemName,  // label as the catalogueId (string)
                    estimatedInstallTimeInMins: estimatedInstallTimeInMins,
                    isRequired: isSerialNumberRequired,
                    image: image
                });

                return acc;
            }, {});

            // Step 2: Create the desired options array
            const optionsArray = Object.keys(groupedByCategory).map((categoryName) => {
                return {
                    label: categoryName,  // Use category name as label
                    options: groupedByCategory[categoryName],  // Use the grouped items as options
                };
            });
            setCatalogueItems(optionsArray);
        }
    }, [catalogItems, workOrderDetails?.CustomerProfile?.[0]]);

    const fetchCatalogItems = async () => {
        setIsCatalogLoading(true);
        try {
            const response = await axiosInstance?.get('', { params: { sp: "usp_GetCatalogueBySolutionId", solutionId: workOrderDetails?.solutionId } });
            if (response) {
                setCatalogItems(response?.data)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsCatalogLoading(false);
        }
    }

    useEffect(() => {
        if (workOrderDetails?.solutionId) {
            fetchCatalogItems();
        }
    }, [workOrderDetails?.solutionId])


    useEffect(() => {
        // Call independent lists first
        dispatch(getTeams(true));
        dispatch(getShifts());
        dispatch(getSebelUsers());
    }, [dispatch]);

    useEffect(() => {
        // Fetch work order details separately
        fetchWorkOrderDetails();
    }, [id]);

    const filterTeams = () => {
        return availableSlots?.filter((team) => {
            const fromTime = new Date(team.FromTime).getTime();
            const toTime = new Date(team.ToTime).getTime();
            const startTime = new Date(workOrderDetails?.scheduledStartDateTime).getTime();
            const endTime = new Date(workOrderDetails?.scheduledEndDateTime).getTime();
            // Check if the scheduled times are between FromTime and ToTime
            return startTime >= fromTime && endTime <= toTime;
        })[0];
    };

    useEffect(() => {
        if (!workOrderDetails) return;

        setSebelUserId(workOrderDetails?.sabelUserId);
        setInvoiceFile(workOrderDetails?.customerInvoicePath);

        // ✅ Safely parse address
        if (workOrderDetails?.customerAddresses) {
            const parsedAddress = JSON.parse(workOrderDetails.customerAddresses)?.[0];
            if (parsedAddress) {
                setSelectedAddress({
                    ...parsedAddress,
                    customerAddressId: workOrderDetails?.customerAddressId,
                });
            }
        }

        // ✅ Handle start date/time safely
        const startDate = workOrderDetails?.scheduledStartDateTime
            ? new Date(workOrderDetails.scheduledStartDateTime)
            : null;

        const endDate = workOrderDetails?.scheduledEndDateTime
            ? new Date(workOrderDetails.scheduledEndDateTime)
            : null;

        if (startDate && !isNaN(startDate)) {
            setScheduledStartDateTime(startDate);

            const timeString = startDate.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23",
            });
            setSelectedTime(timeString);

            setHighlightedSlot({
                teamId: workOrderDetails?.teamId,
                fromTime: startDate.toISOString(),
                toTime: endDate ? endDate.toISOString() : null,
                selectedTime: timeString,
            });
        }

        // ✅ Handle shift
        const team = teams?.Data?.find(
            (item) => item?.teamId == workOrderDetails?.teamId
        );
        if (team) {
            setSelectedShift({
                label: team?.shiftName,
                value: team?.shiftId,
            });
        }

        // Team slot
        setSelectedSlot({ team: filterTeams(), slot: filterTeams() });
    }, [workOrderDetails]);


    const handleDeleteWorkOrderItem = (id) => {
        setWorkOrderItems(workOrderItems.filter((_, index) => index !== id));
        setSelectedSlot(null);
        setSelectedTime(null);
        setHighlightedSlot(null);
        setScheduledStartDateTime('');
    };

    const validationSchema = Yup.object({
        workOrderNumber: Yup.string(),
        teamId: Yup.string(),
        scheduledStartDateTime: Yup.string(),
        agentComments: Yup.string(),
        remedyNumber: Yup.string().required('Remedy Number is required'),
    });


    const handleAddressSelect = (address) => {
        setSelectedAddress(address.customerAddressId === selectedAddress?.customerAddressId ? null : address);
    };

    const [images, setImages] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const fileInputRef = useRef(null);

    // Handle file change (triggered by both drag & drop and input field)
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        // Only allow images to be uploaded
        const imageFiles = files.filter((file) => file.type.startsWith('image/'));

        // Only allow a maximum of 3 images
        if (imageFiles.length + images.length <= 3) {
            imageFiles.forEach((file) => {
                const reader = new FileReader();

                // Convert the image to base64 format and add it to the state
                reader.onloadend = () => {
                    setImages((prevImages) => [...prevImages, { imagePath: reader.result, imageEvent: file?.name }]);
                    setImagePreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(file)]);
                };
                reader.readAsDataURL(file);
            });
        } else {
            alert('You can only upload a maximum of 3 images.');
        }
    };

    // Handle image removal
    const handleRemoveImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setImagePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));

        // Reset the file input if no images are left
        if (images.length === 1) {
            fileInputRef.current.value = '';
        }
    };

    // Handle drag over
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // Handle drag enter
    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // Handle drag leave
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // Handle drop
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = Array.from(e.dataTransfer.files);

        // Only allow images to be uploaded
        const imageFiles = files.filter((file) => file.type.startsWith('image/'));

        // Only allow a maximum of 3 images
        if (imageFiles.length + images.length <= 3) {
            imageFiles.forEach((file) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImages((prevImages) => [...prevImages, reader.result]);
                    setImagePreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(file)]);
                };
                reader.readAsDataURL(file);
            });
        } else {
            alert('You can only upload a maximum of 3 images.');
        }
    };

    const fetchAvailableSlots = async () => {
        setSlotLoading(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: "usp_GetShiftTeamAvailability", shiftId: selectedShift?.value ? selectedShift?.value : null, scheduledDate: scheduledStartDateTime ? scheduledStartDateTime : null, workOrderId: id || null, solutionId: workOrderDetails?.solutionId, customerId: JSON?.parse(workOrderDetails?.CustomerProfile)?.[0]?.customerId } });
            if (response) {
                setAvailableSlots(response?.data?.Data);
            }
        } catch (error) {

        } finally {
            setSlotLoading(false);
        }
    }

    const isBooked = date =>
        bookedDates?.map(item => new Date(item.EngagedDate))?.some(
            booked => booked?.toDateString() === date?.toDateString()
        );

    const fetchCalenderShow = async () => {
        setCalendarLoading(true);
        try {
            const response = await axiosInstance.get(``, { params: { sp: "usp_GetAvailableSlotsByTime", shiftId: selectedShift?.value, requiredDuration: totalTime, solutionId: workOrderDetails?.solutionId, customerId: JSON?.parse(workOrderDetails?.CustomerProfile)?.[0]?.customerId } });
            setBookedDates(response?.data?.Data);
        } catch ({ error }) {
            console.log(error)
        } finally {
            setCalendarLoading(false);
        }
    }

    useEffect(() => {
        if (workOrderItems?.length > 0) {
            const totalMinutes = workOrderItems?.reduce((sum, item) => {
                return sum + (item?.estimatedInstallTimeInMins * item?.quantity);
            }, 0);
            setTotalTime(totalMinutes)
        }
    }, [workOrderItems])

    useEffect(() => {
        if (selectedShift && totalTime && workOrderDetails) {
            fetchCalenderShow()
        }
    }, [selectedShift, totalTime, workOrderDetails])

    useEffect(() => {
        if (scheduledStartDateTime && selectedShift?.value && id) {
            fetchAvailableSlots();
        }
    }, [scheduledStartDateTime, selectedShift, id])

    const toggleModal = () => setModal(!modal);

    const handleSlotClick = (team, slot) => {
        setTeam(team);
        if (workOrderItems?.length <= 0) {
            showError("Please select at least one catalogue item")
        } else {
            setSelectedSlot({ team, slot });
            setTempTime("")
            toggleModal();
        }
    };

    const handleTimeChange = (e) => {
        setTempTime(e.target.value); // only store raw input
    };

    // useEffect(() => {
    //     setSelectedTime(undefined);
    // }, [scheduledStartDateTime]);


    const handleContinue = () => {
        if (!selectedSlot) return;

        if (
            (!tempTime && !selectedTime) ||
            (!tempTime && selectedTime && (
                selectedSlot?.slot.FromTime !== highlightedSlot?.fromTime ||
                selectedSlot?.slot.ToTime !== highlightedSlot?.toTime ||
                selectedSlot?.team.teamId !== highlightedSlot?.teamId
            ))
        ) {
            showError("Please select the time");
            return;
        }

        // Construct date from selectedSlot's date and tempTime
        const selectedDate = new Date(selectedSlot.slot.FromTime);
        const [selectedHour, selectedMinute] = tempTime.split(":");
        selectedDate.setHours(parseInt(selectedHour, 10));
        selectedDate.setMinutes(parseInt(selectedMinute, 10));
        selectedDate.setSeconds(0);
        selectedDate.setMilliseconds(0);

        const selectedStartDateTime = new Date(selectedDate);
        const currentDateTime = new Date();

        // Validate: Must be in future if same day
        const isSameDay = selectedStartDateTime.toDateString() === currentDateTime.toDateString();
        if (isSameDay && selectedStartDateTime <= currentDateTime) {
            showError("Please select a future time");
            return;
        }

        // Validate: estimated time fits in slot
        const totalEstimatedTimeInMs = (workOrderItems?.reduce((sum, item) => {
            return sum + item?.estimatedInstallTimeInMins;
        }, 0) || 0) * 60000;

        const calculatedEndDateTime = new Date(
            selectedStartDateTime.getTime() + totalEstimatedTimeInMs
        );
        const slotEndTime = new Date(selectedSlot.slot.ToTime);

        if (calculatedEndDateTime > slotEndTime) {
            showError("The selected time and estimated work exceed the slot's end time!");
            return;
        }

        // Validate: time is within slot range
        const fromTime = new Date(selectedSlot.slot.FromTime).getTime();
        const toTime = new Date(selectedSlot.slot.ToTime).getTime();
        const selectedTimeInMs = selectedStartDateTime.getTime();

        if (selectedTimeInMs < fromTime || selectedTimeInMs > toTime) {
            showError("Selected time is not within the range of this slot!");
            return;
        }

        // All validations passed — now set selectedTime
        if (tempTime) {
            setSelectedTime(tempTime);
        }

        setHighlightedSlot({
            teamId: selectedSlot.team.teamId,
            fromTime: selectedSlot.slot.FromTime,
            toTime: selectedSlot.slot.ToTime,
            selectedTime: tempTime,
        });

        toggleModal();
    };

    useEffect(() => {
        if (availableSlots) {
            setUniqueTeams(availableSlots?.reduce((acc, team) => {
                if (!acc.some(t => t.teamId === team.teamId)) {
                    acc.push(team);
                }
                return acc;
            }, []))
        }
    }, [availableSlots])

    const handleAddMoreTeam = async (teamId, resetForm) => {
        try {
            const response = await axiosInstance.post('', {
                sp: "usp_AddMoreTeamsToWorkOrder",
                workOrderId: id,
                teamId: teamId
            })
            if (response) {
                showSuccess("Team added successfully!")
                resetForm();
                setVisible(false);
                navigate(`/editWorkOrder/${id}`)
            }
        } catch (error) {

        }
    }

    const deleteExistingTeam = async (teamId) => {
        try {
            const response = await axiosInstance.post('', {
                sp: "usp_DeleteTeamFromWorkOrder",
                workOrderId: id,
                teamId: teamId
            });
            if (response) {
                navigate(`/editWorkOrder/${id}`)
            }
        } catch (error) {

        }
    }

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;

        return (
            <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className='p-2'>
                <img src={`${process.env.REACT_APP_BASE_URL}${data.image}`} alt={data.label} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "10px" }} />
                <span>{data.label}</span>
            </div>
        );
    };

    const checkDate = () => {
        if (scheduledStartDateTime) {
            const selectedStartDateTime = new Date(formatDate(`${scheduledStartDateTime}T${selectedTime}:00`));
            const currentDateTime = new Date();
            // Validate: Must be in future if same day
            const isSameDay = selectedStartDateTime === currentDateTime;
            if (isSameDay) {
                showError("Please select a future start date")
            }
        }
    }

    return (
        <div className="page-content">
            <AddMoreTeams visible={visible} handleClose={() => setVisible(false)} workOrderId={id} onSubmit={handleAddMoreTeam} shiftId={selectedShift?.value} solutionId={workOrderDetails?.solutionId} />
            <div className="d-flex justify-content-between align-items-center mx-2">
                <Breadcrumb title="Edit WorkOrder" breadcrumbItems={[{ title: 'Dashboard', link: '/dashboard' }, { title: 'Edit WorkOrder', link: '#' }]} />
                <Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => navigate(`/workOrderDetails/${id}`)}>
                    Back
                </Button>
            </div>
            {(!loader && workOrderDetails) && (
                <Formik
                    initialValues={{
                        workOrderId: id || '',
                        teamId: workOrderDetails?.teamId || '',
                        scheduledStartDateTime: workOrderDetails?.scheduledStartDateTime || '',
                        scheduledEndDateTime: workOrderDetails?.scheduledEndDateTime || '',
                        agentComments: workOrderDetails?.agentComments || '',
                        invoiceFile: workOrderDetails?.customerInvoicePath || '',
                        remedyNumber: workOrderDetails?.remedyNumber || ''
                    }}
                    validationSchema={validationSchema}
                    onSubmit={async (values) => {
                        if (workOrderItems?.length <= 0) {
                            showError("Please add at least one catalogue item")
                        } else if (!selectedAddress) {
                            showError("Please select the address")
                        } else if (!selectedSlot) {
                            showError("Please select the slot")
                        } else if (!sebelUserId) {
                            showError("Sebel UserId is required")
                        } else {
                            try {
                                setLoading(true)
                                const response = await axiosInstance.post(``, {
                                    "sp": "usp_UpdateWorkOrder",
                                    "workOrderId": id,
                                    "teamId": highlightedSlot?.teamId ? highlightedSlot?.teamId : workOrderDetails?.teamId,
                                    "scheduledStartDateTime": formatDate(
                                        `${scheduledStartDateTime instanceof Date
                                            ? scheduledStartDateTime.toLocaleDateString("en-CA") //  local YYYY-MM-DD
                                            : scheduledStartDateTime}T${selectedTime}:00`
                                    ),
                                    "scheduledEndDateTime": formatDate(
                                        new Date(
                                            `${scheduledStartDateTime instanceof Date
                                                ? scheduledStartDateTime.toLocaleDateString("en-CA") // local YYYY-MM-DD
                                                : scheduledStartDateTime}T${selectedTime}:00`
                                        ).getTime() + (workOrderItems?.reduce((sum, item) => (sum + (item?.estimatedInstallTimeInMins * item?.quantity)), 0) * 60000)
                                    ),
                                    "agentComments": values?.agentComments,
                                    "remedyNumber": values?.remedyNumber,
                                    "customerAddressId": selectedAddress?.customerAddressId,
                                    "workOrderItemsJson": JSON?.stringify({ items: workOrderItems?.map(item => ({ catalogueId: item?.catalogueId, quantity: item?.quantity, serialNumber: item?.serialNumber })) }),
                                    "workOrderLocationImagesJson": JSON?.stringify({ images: images }),
                                    "customerInvoicePath": invoiceFile,
                                    "solutionId": workOrderDetails?.solutionId,
                                    "sabelUserId": sebelUserId
                                }
                                )
                                if (response) {
                                    showSuccess('Work Order Updated Successfully')
                                    setLoading(false)
                                    navigate(`/workOrderDetails/${id}`)
                                    setImages("")
                                    setImagePreviews("")
                                }
                            } catch (error) {
                                setLoading(false)
                            }
                        }
                    }}
                >
                    {({ setFieldValue, values, errors, touched }) => (
                        <Form className='bg-white p-3 rounded-2'>
                            <Row>
                                <Col md={6}>
                                    <div className='' >
                                        <label for="sebelUserId" className=''>Siebel User ID</label>
                                        <Select
                                            id="sebelUserId"
                                            options={sebelUsers?.Data?.map(item => ({ label: item?.sabelUserId, value: item?.id }))}
                                            value={sebelUsers?.Data?.map(item => ({ label: item?.sabelUserId, value: item?.id }))?.find(option => option?.value == sebelUserId || "")}
                                            isLoading={sebelUsersLoading}
                                            onChange={option => { setSebelUserId(option?.value || "") }}
                                            placeholder="Select Siebel User ID"
                                            isClearable={true}
                                            styles={{
                                                container: (base) => ({
                                                    ...base,
                                                    maxWidth: '200px',
                                                }),
                                            }}
                                        />
                                        {errors.sebelUserId && <div className="text-danger">{errors.sebelUserId}</div>}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <label htmlFor="remedyNumber">Remedy Number</label> <span className='text-danger'>*</span>
                                    <Field
                                        name="remedyNumber"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Remedy Number"
                                    />
                                    <ErrorMessage name="remedyNumber" component="div" className="text-danger" />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={6}>
                                    <label htmlFor="workOrderId">Work Order Number</label> <span className='text-danger'>*</span>
                                    <Field
                                        name="workOrderNumber"
                                        type="text"
                                        value={workOrderDetails?.workOrderNumber}
                                        className="form-control"
                                        disabled
                                        placeholder="Work Order ID"
                                    />
                                    <ErrorMessage name="workOrderId" component="div" className="text-danger" />
                                </Col>
                                <Col md={6}>
                                    <label htmlFor="invoiceFile">Invoice File (Upload new if you wish to change.) <Link className="text-primary" style={{ textDecoration: 'underline !important' }} to={workOrderDetails?.customerInvoicePath ? `${process.env.REACT_APP_BASE_URL + workOrderDetails?.customerInvoicePath}` : "#"} target={workOrderDetails?.customerInvoicePath ? "_blank" : "_self"}>View Existing</Link></label>
                                    <input
                                        name="invoiceFile"
                                        type="file"
                                        className="form-control"
                                        onChange={handleInvoiceFileChange}
                                        accept=".pdf"
                                    />
                                    {/* {fileError && <div className="text-danger">{fileError}</div>} */}
                                    <ErrorMessage name="invoiceFile" component="div" className="text-danger" />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={6}>
                                    {/* <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                    <Input
                                        type="date"
                                        value={scheduledStartDateTime}
                                        onChange={(e) => { setScheduledStartDateTime(e.target.value); setFieldValue('scheduledStartDateTime', e.target.value); setSelectedSlot(""); setSelectedTime(undefined); setHighlightedSlot(null);}}
                                        min={new Date().toISOString().split('T')[0]}
                                        placeholder="Scheduled Start Date"
                                        style={{ border: "1px solid lightgray", height: "38px" }}
                                    /> */}
                                    <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                    {calendarLoading && <span className="ms-3"><ClipLoader size={12} color="#000" /> Fetching available dates...</span>}
                                    <DatePicker
                                        selected={scheduledStartDateTime}
                                        onChange={(date) => {
                                            if (date) {
                                                const corrected = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                                                setScheduledStartDateTime(corrected);
                                            } else {
                                                setScheduledStartDateTime(null);
                                            }
                                        }}
                                        filterDate={(date) => {
                                            // Disable booked, past dates, and Fridays
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);

                                            const isFriday = date.getDay() === 5; // 0=Sunday, 5=Friday

                                            return date >= today && !isBooked(date) && !isFriday;
                                        }}
                                        dayClassName={(date) => {
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);

                                            const isFriday = date.getDay() === 5; // Fridays
                                            const isToday =
                                                date.getDate() === today.getDate() &&
                                                date.getMonth() === today.getMonth() &&
                                                date.getFullYear() === today.getFullYear();

                                            const isSelected =
                                                scheduledStartDateTime &&
                                                date.getDate() === scheduledStartDateTime.getDate() &&
                                                date.getMonth() === scheduledStartDateTime.getMonth() &&
                                                date.getFullYear() === scheduledStartDateTime.getFullYear();

                                            if (isFriday) return "friday-disabled"; 
                                            if (isBooked(date)) return "booked-date"; 
                                            if (isToday) return "today-highlight"; 
                                            if (isSelected) return "selected-date";
                                            return undefined;
                                        }}
                                        className="form-control custom-datepicker"
                                        dateFormat="yyyy-MM-dd"
                                    />


                                    {/* {errors?.scheduledStartDateTime && <span className='text-danger'>{errors?.scheduledStartDateTime}</span>} */}
                                    <ErrorMessage name="scheduledStartDateTime" component="div" className="text-danger" />
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Select Shift</Label> <span className='text-danger'>*</span>
                                        <Select
                                            options={shifts?.Data?.map(item => ({ label: item?.shiftName, value: item?.shiftId }))}
                                            value={selectedShift}
                                            isLoading={shiftsLoading}
                                            onChange={setSelectedShift}
                                            placeholder="Select a Shift"
                                            isClearable={true}
                                        />
                                        {errors.selectedShift && <div className="text-danger">{errors.selectedShift}</div>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="pb-3">
                                <h5>Available Slots <span className='' style={{ fontSize: "14px" }}> (Current Slot: {
                                    selectedTime ? selectedTime : new Date(workOrderDetails?.scheduledStartDateTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })
                                }{" "}
                                    -{" "}
                                    {selectedTime ? addMinutesToTime(selectedTime, workOrderItems?.reduce((sum, item) => {
                                        return sum + (item?.estimatedInstallTimeInMins * item?.quantity);
                                    }, 0)) : new Date(workOrderDetails?.scheduledEndDateTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })})</span></h5>
                                <Col md={12} style={{ overflowX: "auto" }}>
                                    {slotLoading ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px" }}>
                                            <ClipLoader size={30} color="#0d6efd" />
                                        </div>
                                    ) : (
                                        <Table hover>
                                            <thead>
                                                {/* <tr>
                                                <th>Team</th>
                                                <th>Available Slots</th>
                                            </tr> */}
                                            </thead>
                                            <tbody>
                                            {uniqueTeams?.map((team, index) => (
                                                <tr key={team.teamId}>
                                                    <td className="" style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{authUser?.userRole === "Super Admin" ? team?.teamName : authUser?.userRole === "Supervisor" ? team?.teamName : `Slot-${index + 1}`}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-start align-items-center gap-3">
                                                            {availableSlots?.filter((slot) => slot.teamId === team.teamId)
                                                                .reduce((uniqueSlots, slot) => {
                                                                    if (
                                                                        !uniqueSlots.some(
                                                                            (s) => s.FromTime === slot.FromTime && s.ToTime === slot.ToTime
                                                                        )
                                                                    ) {
                                                                        uniqueSlots.push(slot);
                                                                    }
                                                                    return uniqueSlots;
                                                                }, [])
                                                                .map((slot, index) => (
                                                                    <div
                                                                        key={index}
                                                                        onClick={() =>
                                                                            slot.TimeType !== "Engaged" ? handleSlotClick(team, slot) : ""
                                                                        }
                                                                        style={{
                                                                            backgroundColor:
                                                                                slot.TimeType === "Engaged" ? "lightgray" : "rgb(144, 238, 144)",
                                                                            padding: "7px",
                                                                            margin: "5px 0",
                                                                            cursor: slot.TimeType === "Engaged" ? "not-allowed" : "pointer",
                                                                            opacity: slot.TimeType === "Engaged" ? 0.5 : 1,
                                                                            border: highlightedSlot?.teamId == team.teamId &&
                                                                                (highlightedSlot?.selectedTime >= new Date(slot.FromTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                }) &&
                                                                                    highlightedSlot?.selectedTime < new Date(slot.ToTime).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                        hour12: false
                                                                                    }))
                                                                                ? "2px solid blue"
                                                                                : "1px solid lightgray",
                                                                            borderRadius: "5px",
                                                                            whiteSpace: "nowrap",
                                                                            color: highlightedSlot?.teamId == team.teamId &&
                                                                                highlightedSlot?.selectedTime >= new Date(slot.FromTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                }) &&
                                                                                highlightedSlot?.selectedTime < new Date(slot.ToTime).toLocaleTimeString([], {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: false
                                                                                })
                                                                                ? "blue"
                                                                                : slot.TimeType === "Engaged" ? "black" : "white",
                                                                            fontSize: "12px"
                                                                        }}
                                                                    >
                                                                        {new Date(slot.FromTime).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })}{" "}
                                                                        -{" "}
                                                                        {new Date(slot.ToTime).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {uniqueTeams?.length <= 0 && <div className='text-center'>No Slots Available</div>}
                                        </tbody>
                                    </Table>
                                    )}
                                </Col>
                            </Row>

                            {(authUser?.userRole === "Super Admin" || authUser?.userRole === "Supervisor") && <div className='py-3 px-2' style={{ border: "1px solid lightgray", borderRadius: "8px" }}>
                                <h6 className='mb-3'>Manage teams</h6>
                                <div className='d-flex align-items-center flex-wrap gap-2 mb-3'>
                                    {JSON.parse(workOrderDetails?.Teams)?.map((team, index) => (
                                        <div key={index} className='px-2 py-1' style={{ border: "1px solid lightgray", borderRadius: "6px", }}>
                                            {team?.teamName}
                                            {JSON.parse(workOrderDetails?.Teams)?.length > 1 && <span
                                                onClick={() => { deleteExistingTeam(team?.teamId) }}
                                                title='delete team'
                                                style={{ marginLeft: '10px', backgroundColor: "lightgray", border: "none" }}
                                            >
                                                <IoCloseOutline size={20} color='gray' />
                                            </span>}
                                        </div>
                                    ))}
                                </div>
                                <div className="bg-primary text-white p-2 rounded d-inline " style={{ cursor: "pointer" }} onClick={() => setVisible(true)}>Add More Teams</div>
                            </div>}

                            {selectedSlot && <Modal isOpen={modal} toggle={toggleModal} centered>
                                <ModalHeader toggle={toggleModal}>Select Time</ModalHeader>
                                <ModalBody>
                                    <div>
                                        Selected Slot : {new Date(selectedSlot?.slot?.FromTime).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}{" "}
                                        -{" "}
                                        {new Date(selectedSlot?.slot?.ToTime).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <label>Select Time:</label>
                                        <input
                                            type="time"
                                            value={(highlightedSlot?.teamId == team?.teamId &&
                                                highlightedSlot?.selectedTime >= new Date(selectedSlot?.slot?.FromTime).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false
                                                }) &&
                                                highlightedSlot?.selectedTime < new Date(selectedSlot?.slot?.ToTime).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false
                                                })
                                            ) ? tempTime || selectedTime : tempTime}
                                            onChange={handleTimeChange}
                                            min={formatTime(selectedSlot?.slot?.FromTime)}
                                            max={formatTime(selectedSlot?.slot?.ToTime)}
                                        />
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={handleContinue}>
                                        Continue
                                    </Button>
                                    <Button color="secondary" onClick={toggleModal}>
                                        Cancel
                                    </Button>
                                </ModalFooter>
                            </Modal>}

                            <Row className="mt-3">
                                <Col md={12}>
                                    <label htmlFor="agentComments">Agent Comments</label>
                                    <Field
                                        name="agentComments"
                                        as="textarea"
                                        className="form-control"
                                        placeholder="Enter agent comments"
                                    />
                                    <ErrorMessage name="agentComments" component="div" className="text-danger" />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={12}>
                                    <h5>Select Address <span className='text-danger'>*</span></h5>
                                    <div className="d-flex flex-wrap">
                                        {availableAddresses?.Data?.map((address) => (
                                            <Card
                                                key={address.customerAddressId}
                                                className={`m-2 ${selectedAddress?.customerAddressId === address.customerAddressId ? 'border-success' : 'border-secondary'}`}
                                                onClick={() => handleAddressSelect(address)}  // Entire Card is clickable
                                                style={{
                                                    cursor: 'pointer',
                                                    width: '200px',
                                                    transition: 'box-shadow 0.3s ease',
                                                    boxShadow: selectedAddress?.customerAddressId === address.customerAddressId
                                                        ? '0 4px 8px rgba(0, 123, 255, 0.5)'
                                                        : '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <CardBody>
                                                    <FormGroup check>
                                                        <Label check style={{ cursor: 'pointer' }}> {/* Ensure label is also clickable */}
                                                            {/* Remove the Input's readOnly */}
                                                            <Input
                                                                type="radio"
                                                                name="address"
                                                                checked={selectedAddress?.customerAddressId === address.customerAddressId}
                                                                onChange={() => { }} // No need for any logic on change

                                                            />
                                                            <h5>Address #{address.customerAddressId}</h5>
                                                            <p className='mb-0'>{address.addressLine}, {address.area}</p>
                                                            <p className='mb-0'>{address.areaDescription}</p>
                                                            <p>{address.landmark}</p>
                                                        </Label>
                                                    </FormGroup>
                                                </CardBody>
                                            </Card>
                                        ))}
                                    </div>
                                </Col>
                            </Row>

                            {/* Work Order Items Section */}
                            {<div>
                                <h5>Add Work Order Items</h5>
                                <div className="d-flex gap-2 align-items-center flex-wrap">
                                    <div className="flex-grow-1">
                                        <Select
                                            options={catalogueItems}
                                            value={selectedCatalogItem}
                                            isLoading={isCatalogLoading}
                                            onChange={setSelectedCatalogItem}
                                            placeholder="Select Catalog Item"
                                            isClearable={true}
                                            components={{ Option: customOption }}
                                        />
                                    </div>
                                    <div className="flex-grow-1">
                                        <Input
                                            type="number"
                                            value={itemQuantity}
                                            onChange={(e) => setItemQuantity(e.target.value)}
                                            placeholder="Quantity"
                                            style={{ height: "38px", border: "1px solid lightgray" }}
                                        />
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <Button color="primary" onClick={handleAddWorkOrderItem}>
                                            + Add Item
                                        </Button>
                                    </div>
                                </div>

                                {/* Serial Number Modal */}
                                <Modal isOpen={modalSerialNoOpen} toggle={() => setModalSerialNoOpen(!modalSerialNoOpen)} className='modal-dialog-centered' backdrop="static">
                                    <ModalHeader toggle={() => setModalSerialNoOpen(false)}>Enter Serial Numbers</ModalHeader>
                                    <ModalBody>
                                        {serialNumbers.map((serial, index) => (
                                            <Input
                                                key={index}
                                                type="text"
                                                value={serial}
                                                onChange={(e) => handleSerialNumberChange(index, e.target.value)}
                                                placeholder={`Serial Number ${index + 1}`}
                                                style={{ marginBottom: "10px" }}
                                            />
                                        ))}

                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={handleConfirmSerialNumbers}>
                                            Confirm
                                        </Button>
                                        <Button color="secondary" onClick={() => setModalSerialNoOpen(false)}>
                                            Cancel
                                        </Button>
                                    </ModalFooter>
                                </Modal>

                            </div>}

                            {/* Work Order Items Table */}
                            {workOrderItems?.length > 0 && (
                                <Table responsive striped className='mt-3' style={{ border: "1px solid lightgray" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: "1px solid lightgray" }}>Image</th>
                                            <th style={{ border: "1px solid lightgray" }}>Item</th>
                                            <th style={{ border: "1px solid lightgray" }}>Time per item</th>
                                            <th style={{ border: "1px solid lightgray" }}>Time</th>
                                            <th style={{ border: "1px solid lightgray" }}>Serial Number</th>
                                            <th style={{ border: "1px solid lightgray" }}>Quantity</th>
                                            <th style={{ border: "1px solid lightgray" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {workOrderItems?.map((item, index) => (
                                            <tr key={index}>
                                                <td className='border-1'>{<img src={`${process.env.REACT_APP_BASE_URL}${item?.image}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />}</td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    {item.catalogueItem}
                                                </td>
                                                <td style={{ verticalAlign: "middle" }} className="text-center">{(() => {
                                                    const totalMinutes = item?.estimatedInstallTimeInMins; // Total time in minutes
                                                    const hours = Math.floor(totalMinutes / 60); // Calculate hours
                                                    const minutes = totalMinutes % 60; // Calculate remaining minutes

                                                    return hours > 0
                                                        ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                                        : `${minutes} min${minutes > 1 ? 's' : ''}`;
                                                })()}</td>

                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    {(() => {
                                                        const totalMinutes = item?.estimatedInstallTimeInMins * item?.quantity; // Total time in minutes
                                                        const hours = Math.floor(totalMinutes / 60); // Calculate hours
                                                        const minutes = totalMinutes % 60; // Calculate remaining minutes

                                                        return hours > 0
                                                            ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                                            : `${minutes} min${minutes > 1 ? 's' : ''}`;
                                                    })()}
                                                </td>
                                                <td className='border-1 text-center' style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>{item?.serialNumber || 'N/A'}</td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    {item.quantity}
                                                </td>
                                                <td className="text-center" style={{ border: "1px solid lightgray", verticalAlign: "middle" }}>
                                                    <Button color="danger" onClick={() => handleDeleteWorkOrderItem(index)}>
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}

                            <h6>Total Estimated Time: <span>{(() => {
                                const totalMinutes = workOrderItems?.reduce((sum, item) => {
                                    return sum + (item?.estimatedInstallTimeInMins * item?.quantity);
                                }, 0) / workOrderDetails?.TotalTeams;

                                const hours = Math.floor(totalMinutes / 60); // Calculate hours
                                const minutes = totalMinutes % 60; // Calculate remaining minutes

                                return hours > 0
                                    ? `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
                                    : `${minutes} min${minutes > 1 ? 's' : ''}`;
                            })()}</span></h6>

                            <div className="container">
                                <Row className="mb-4">
                                    <Col xs="12">
                                        <div
                                            className="upload-area"
                                            style={{
                                                border: '2px dashed #007bff',
                                                padding: '40px',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                borderRadius: '8px',
                                            }}
                                            onClick={() => fileInputRef.current.click()}
                                            onDragOver={handleDragOver}
                                            onDragEnter={handleDragEnter}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                        >
                                            <FaCloudUploadAlt size={50} color="#007bff" />
                                            <p style={{ color: '#007bff', fontSize: '16px' }}>Drag and drop images here or click to select</p>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                                style={{ display: 'none' }} // Hide the default file input
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    {imagePreviews.map((preview, index) => (
                                        <Col key={index} xs="12" md="4" className="mb-3 position-relative">
                                            <div
                                                className="image-preview-container"
                                                style={{
                                                    position: 'relative',
                                                    display: 'inline-block',
                                                    width: '100%',
                                                    height: 'auto',
                                                }}
                                            >
                                                <img
                                                    src={preview}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleRemoveImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '5px',
                                                        right: '5px',
                                                        zIndex: 1,
                                                        backgroundColor: 'red',
                                                        borderColor: 'red',
                                                    }}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="mt-4">
                                <Button color="primary" type="submit" style={{ minWidth: "113px" }} onClick={checkDate}>
                                    {loading ? <ClipLoader color='white' size={16} /> : "Save Changes"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            )}
            {loader && (
                <div className="bg-white p-4 rounded-3 mt-4" style={{ minHeight: '600px' }}>
                    <Row className="mb-4">
                        <Col md={4}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '40%' }} /></Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                        <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} /></Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={6}><Skeleton active paragraph={{ rows: 1 }} title={{ width: '30%' }} /></Col>
                        <Col md={6}><Skeleton active paragraph={{ rows: 2 }} title={{ width: '40%' }} /></Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={12}>
                            <Skeleton active paragraph={{ rows: 5 }} title={{ width: '20%' }} />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={12}>
                            <Skeleton.Button active block size="large" style={{ height: '150px' }} />
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
};

export default EditWorkOrder;
